/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from 'react';
import { ExdsText } from '@exds/core';
import { ExdsIconCheckmark, ExdsIconForward } from '@exds/icons';
import './VerticalStepper.scss';

const VerticalStepper = ({ steps, currentStep, onStepClick, sid }) => {
  const getStepStatus = (stepIndex) => {
    const step = steps[stepIndex - 1];
    if (step.status === 'skipped') {
      return 'skipped';
    }
    return currentStep.main === stepIndex ? 'active' : currentStep.main > stepIndex ? 'completed' : 'disabled';
  };

  const getSubStepStatus = (mainStepIndex, subStepIndex) => {
    if (currentStep.main > mainStepIndex) {
      return 'completed';
    }
    if (currentStep.main === mainStepIndex) {
      return currentStep.sub === subStepIndex ? 'active' : currentStep.sub > subStepIndex ? 'completed' : 'disabled';
    }
    return 'disabled';
  };

  return (
    <div className="vertical-stepper" role="navigation" aria-label="Progress">
      <ExdsText primitive="h1" textStyle="bodyLargeHeavier" className="header">Mobile App Setup</ExdsText>
      <ExdsText primitive="span">Standard ID (SID): {sid}</ExdsText>
      <br /><br />
      {steps.map((mainStep, index) => (
        <div key={index} className={`main-step ${getStepStatus(index + 1)}`}>
          <div className={`step-indicator ${getStepStatus(index + 1)}`}>
            {getStepStatus(index + 1) === 'completed' ? (
              <ExdsIconCheckmark aria-hidden color="inverse" size="medium" />
            ) : getStepStatus(index + 1) === 'skipped' ? (
              <ExdsIconForward aria-hidden color="inverse" size="medium" />
            ) : (
              <div className="step-number">{index + 1}</div>
            )}
          </div>
          <div className={`step-title ${getStepStatus(index + 1)}`}>
            {getStepStatus(index + 1) === 'skipped' ? (
              <button
                onClick={() => onStepClick(index + 1)}
                className="skipped-link"
              >
                {mainStep.title}
              </button>
            ) : (
              mainStep.title
            )}
          </div>
          {getStepStatus(index + 1) === 'active' && mainStep.subSteps && (
            <ol className="sub-steps">
              {mainStep.subSteps.map((subStep, subIndex) => (
                <li key={subIndex} className={`sub-step ${getSubStepStatus(index + 1, subIndex + 1)}`}>
                  <div className={`sub-step-indicator ${getSubStepStatus(index + 1, subIndex + 1)}`}>
                    {getSubStepStatus(index + 1, subIndex + 1) === 'completed' ? (
                      <ExdsIconCheckmark aria-hidden color="inverse" size="small" />
                    ) : (
                      <div className="sub-step-number" />
                    )}
                  </div>
                  <div className={`sub-step-title ${getSubStepStatus(index + 1, subIndex + 1)}`}>{subStep.title}</div>
                </li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  );
};

export default VerticalStepper;
